module.exports = __webpack_public_path__ + "img/SLT_0779-Bearbeitet.56e2388a.jpg";